import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { SearchableCard, Spacing } from "@snapchat/snap-design-system";

export const TitleCase = styled.div`
    text-transform: lowercase;

    &:first-letter {
        text-transform: capitalize;
    }
`;

export const AssetsCard = styled(SearchableCard)`
    min-height: 80vh;

    .sds-vtable-row {
        width: 100%;
    }
`;

export const alertStyle = css`
    margin-top: ${Spacing.MD}px;
`;

export const BoldText = styled.span`
    font-weight: bold;
`;
